"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _blocks = require("@wordpress/blocks");

/**
 * WordPress dependencies
 */
const transforms = {
  to: [{
    type: 'block',
    blocks: ['core/columns'],
    transform: _ref => {
      let {
        className,
        columns,
        content,
        width
      } = _ref;
      return (0, _blocks.createBlock)('core/columns', {
        align: 'wide' === width || 'full' === width ? width : undefined,
        className,
        columns
      }, content.map(_ref2 => {
        let {
          children
        } = _ref2;
        return (0, _blocks.createBlock)('core/column', {}, [(0, _blocks.createBlock)('core/paragraph', {
          content: children
        })]);
      }));
    }
  }]
};
var _default = transforms;
exports.default = _default;
//# sourceMappingURL=transforms.js.map